/** Default register API (standalone multi-product). */
export const STANDALONE_REGISTER_API_BASE = 'https://standalone.mrnware.com/api';

/**
 * Register API base URL per `project_type` when signup hits a product backend directly.
 * Endpoint used: `{base}/register`
 */
export const REGISTER_API_BASE_BY_PROJECT_TYPE: Record<string, string> = {
    hr_management: 'https://hrmback.mrnware.com/api',
};

export function registerApiBaseForProjectType(projectType: string): string {
    return REGISTER_API_BASE_BY_PROJECT_TYPE[projectType] ?? STANDALONE_REGISTER_API_BASE;
}

export function buildRegisterUrl(projectType: string, social?: string | null): string {
    const base = registerApiBaseForProjectType(projectType);
    const url = `${base}/register`;
    if (social) return `${url}?social=${encodeURIComponent(social)}`;
    return url;
}

export function usesStandaloneRegisterApi(projectType: string): boolean {
    return !REGISTER_API_BASE_BY_PROJECT_TYPE[projectType];
}
